// import DateFnsUtils from '@date-io/date-fns';
import CssBaseline from '@mui/material/CssBaseline';
import {ThemeProvider , createTheme} from '@mui/material/styles';
import { darken, lighten } from '@mui/material/styles';
import React from 'react';

// A theme with custom primary and secondary color.
// It's optional.
const defaultTheme = createTheme({
   overrides: {
      MuiFormLabel: { // Name of the component ⚛️ / style sheet
         asterisk: { // Name of the rule
            display: 'none', // Some CSS
         },
      },
   },
   palette: {
      primary: {
         light: lighten('#1E2021', 0.1),
         main: '#1E2021',
         dark: darken('#1E2021', 0.1),//'#21355A',
      },
      //#C32127
      secondary: {
         light: lighten('#A90004', 0.1),
         main: '#A90004',
         dark: darken('#A90004', 0.1),//'#21355A',
      },
   },
   typography: {
      fontFamily: '"prometo", "Montserrat", "Arial", "Helvetica Neue", "Helvetica", sans-serif;',
   },
});

/**
 * An HOC component to handle setting up the Material-UI theme and provider.
 * @param theme The theme for the application.
 * @param Component The component to apply the theme to.
 * @return {function(*): *}
 */
export default function withRoot(theme =  defaultTheme, Component) {
   const useTheme = createTheme(theme);
   function WithRoot(props) {
      // MuiThemeProvider makes the theme available down the React tree
      // thanks to React context.
      return (
         <ThemeProvider  theme={useTheme}>
            {/*<MuiPickersUtilsProvider utils={DateFnsUtils}>*/}
               <CssBaseline/>
               <Component {...props} />
            {/*</MuiPickersUtilsProvider>*/}
         </ThemeProvider >
      );
   }

   return WithRoot;
}
